module.exports = __webpack_public_path__ + "static/media/ecaf.87bd0078.jpg";